import { Button, Icon } from "semantic-ui-react";
import React from "react";

export const PaginationButtons = ({ previous, next, onPrevious, onNext }) => {
  if (!previous && !next) return null;

  return (
    <div style={{ textAlign: "right", marginBottom: "2rem" }}>
      <Button disabled={!previous} onClick={onPrevious}>
        <Icon name="arrow left" />
        Anterior
      </Button>
      <Button disabled={!next} onClick={onNext}>
        Próximo
        <Icon name="arrow right" />
      </Button>
    </div>
  );
};
